module.exports = __webpack_public_path__ + "img/Monkey-Logo-Template.jpg";